import { HeaderCtaProps } from './types';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import { toCta } from 'components/shared/CTA/toCta';
import Link from 'components/shared/Link/Link';
import { cn, getColorway } from 'utils/styles';
import { getColorwayName } from 'utils/formatters';
import { Colorways } from 'types/constants';
import ChimeLogo from 'components/shared/ChimeLogo/ChimeLogo';
import { getEntryNativeFields } from 'utils/entryNativeFields';

const HeaderCta = (props: HeaderCtaProps) => {
  const { cta, color } = getEntryNativeFields(props);
  const flatCta = toCta(cta);

  return (
    <div
      className={cn('px-6 sm:px-14 py-4 flex justify-between h-18', getColorway(color))}
      data-testid="header-cta"
      data-theme={'dark'}>
      <Link href="/">
        <ChimeLogo
          color={getColorwayName(color) === Colorways.Inverse ? 'primary_neutral' : 'chime_green'}
          alt="Chime Home"
        />
      </Link>

      <div className="sm:min-w-[200px] h-full flex">{isValidCta(flatCta) && <CTA cta={flatCta} />}</div>
    </div>
  );
};

export default HeaderCta;
